import SectionHeading from "@/components/feature/SectionHeading";
import { testimonials } from "@/mocks/gossip";

export default function Testimonials() {
  return (
    <section className="w-full bg-background-50" aria-labelledby="voice-title">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <h2 id="voice-title" className="sr-only">
          吃瓜群众怎么说
        </h2>
        <SectionHeading
          kicker="口碑"
          title="吃瓜群众怎么说"
          desc="来自长期用户的真实反馈，也是我们持续把时间线做细的理由。"
          align="center"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                <i className="ri-double-quotes-l text-base" aria-hidden="true"></i>
              </span>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-background-200 pt-3">
                <span className="block text-sm font-bold text-foreground-950">{item.name}</span>
                <span className="mt-0.5 block text-xs text-foreground-500">{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}